export default __webpack_public_path__ + "media/Dry-Food-Pasta-Noodles.200e2b2d.png";